import {
  DWELLER_USER_ROLE,
  LANDLORD_USER_ROLE,
  ROLE_TRANSLATION_ALIASES,
  STAFF_USER_ROLES,
} from '../../../constants/user'

export function getUserRoleSelectDwellerOption(t) {
  return {
    label: t(ROLE_TRANSLATION_ALIASES[DWELLER_USER_ROLE]),
    value: DWELLER_USER_ROLE,
  }
}

export function getUserRoleSelectLandlordOption(t) {
  return {
    label: t(ROLE_TRANSLATION_ALIASES[LANDLORD_USER_ROLE]),
    value: LANDLORD_USER_ROLE,
  }
}

export function getUserRoleSelectOptions(t) {
  return [getUserRoleSelectDwellerOption(t), getUserRoleSelectLandlordOption(t)]
}

export function getUserRoleSelectStaffOptions(t) {
  return STAFF_USER_ROLES.map(role => ({
    label: t(ROLE_TRANSLATION_ALIASES[role]),
    value: role,
  }))
}
